/* eslint-disable */
import React from 'react';
import {
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  Typography,
  Box,
  IconButton,
  Paper,
  Link,
  Chip,
  Button,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Carousel from 'react-material-ui-carousel';
import './ClubDetailDialog.css';
import { OpenInNewOutlined } from '@material-ui/icons';
import { ReactComponent as EditPenIconGreen } from '../../../assets/images/EditPenGreen.svg';
import { backendLocalUrl } from '../../../constants/globalConstants';

const ClubDetailDialog = ({
  open,
  onClose,
  clubData,
  onEdit,
  publicView = false,
  isAccessible = false,
}) => {
  if (!clubData) return null;

  // Build club details from clubData
  const clubDetails = {
    name: clubData?.clubName || 'N/A',
    category: clubData?.clubCategory?.clubCategoryName || 'N/A',
    // Handle multiple types from clubTypes array (new format) or single clubType (old format)
    type:
      clubData?.clubTypes && Array.isArray(clubData.clubTypes)
        ? clubData.clubTypes // Array of type objects from new format
        : Array.isArray(clubData?.clubType)
        ? clubData.clubType // Array of type objects (legacy)
        : clubData?.clubType?.clubTypeName
        ? [
            {
              amenityTypeName: clubData.clubType.clubTypeName,
              clubTypeName: clubData.clubType.clubTypeName,
            },
          ] // Single type wrapped in array (legacy)
        : [],
    description: clubData?.clubDesc || 'No description available',
    preferredContact: clubData?.clubEmail || 'N/A',
    phone: clubData?.clubPhone || 'N/A',
    address: clubData?.clubAddress || 'N/A',
    website: clubData?.clubWebsite || 'N/A',
    images:
      clubData?.clubGallery?.map((img) => ({
        image:
          window.location.hostname === 'localhost'
            ? `${backendLocalUrl}/${img.image}`
            : `api/${img.image}`,
        alt: clubData?.clubName || 'Club Image',
      })) || [],
  };

  // compute a safe external href (keep displayed text unchanged)
  const websiteHref = clubDetails.website
    ? /^https?:\/\//i.test(clubDetails.website)
      ? clubDetails.website
      : `https://${clubDetails.website.replace(/^(https?:\/\/)+/i, '')}`
    : clubDetails.website;

  return (
    <Dialog
      className="CustomDialog ClubDetailDialog"
      onClose={onClose}
      aria-labelledby="club-detail-dialog-title"
      open={open}
      maxWidth="md"
      fullWidth
    >
      <MuiDialogTitle id="club-detail-dialog-title" className="CustomDialogTitle">
        <Box className="ClubDetailImageContainer">
          <Carousel
            navButtonsAlwaysVisible={true}
            autoPlay={false}
            className="ClubDetailCarousel"
            navButtonsProps={{
              style: {
                backgroundColor: '#000',
                padding: '0',
                opacity: 0.6,
              },
            }}
            indicatorIconButtonProps={{
              style: {
                padding: '0px',
                color: 'rgba(255, 255, 255, 0.6)',
              },
            }}
            activeIndicatorIconButtonProps={{
              style: {
                padding: '0px',
                color: 'rgba(255, 255, 255, 1)',
              },
            }}
            indicatorContainerProps={{
              style: {
                marginTop: '0px',
                position: 'absolute',
                bottom: '5px',
              },
            }}
          >
            {clubDetails.images.length > 0 ? (
              clubDetails.images.map((img, i) => (
                <Paper key={i}>
                  <Box className="ClubDetailBannerBox">
                    <img src={img.image} alt={img.alt} />
                  </Box>
                </Paper>
              ))
            ) : (
              <Paper>
                <Box className="ClubDetailBannerBox">
                  <img
                    src={
                      window.location.hostname === 'localhost'
                        ? `${backendLocalUrl}/assets/images/NoImage.png`
                        : `api/assets/images/NoImage.png`
                    }
                    alt="No Image"
                  />
                </Box>
              </Paper>
            )}
          </Carousel>
        </Box>
        {console.log(isAccessible, publicView, '22222222222')}
        {isAccessible && !publicView && (
          <Button
            className="EditCommonButtonFloatSecond"
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<EditPenIconGreen />}
            onClick={() => onEdit && onEdit(clubData)}
          >
            Edit
          </Button>
        )}
        <IconButton className="CustomCloseIcon" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </MuiDialogTitle>

      <MuiDialogContent className="CustomDialogContent ClubDetailContent">
        {/* Club Image Carousel */}

        {/* Club Category */}
        {clubDetails.category && clubDetails.category !== 'N/A' && (
          <Box className="ClubDetailCategory">
            <Typography variant="overline" className="CategoryLabel" color="textSecondary">
              {clubDetails.category}
            </Typography>
          </Box>
        )}

        {/* Club Name */}
        {clubDetails.name && clubDetails.name !== 'N/A' && (
          <Box className="ClubDetailName">
            <Typography variant="h2" component="h2" className="ClubNameDetail" color="textPrimary">
              {clubDetails.name}
            </Typography>
            <Box className="ClubTagsContent">
              {Array.isArray(clubDetails.type) && clubDetails.type.length > 0 ? (
                clubDetails.type.map((typeObj, index) => (
                  <Chip
                    key={index}
                    label={typeObj?.amenityTypeName || typeObj?.clubTypeName || 'N/A'}
                    className="ClubTag"
                  />
                ))
              ) : clubDetails.type && clubDetails.type !== 'N/A' ? (
                <Chip label={clubDetails.type} className="ClubTag" />
              ) : null}
            </Box>
          </Box>
        )}

        {/* Description Section */}
        {clubDetails.description &&
          clubDetails.description !== 'N/A' &&
          clubDetails.description !== 'No description available' && (
            <Box className="ClubDetailSection">
              <Typography variant="caption" className="SectionTitle" color="textSecondary">
                Description
              </Typography>
              <Typography variant="body2" className="SectionContent" color="textPrimary">
                {clubDetails.description}
              </Typography>
            </Box>
          )}

        {/* Contact Information */}
        {clubDetails.preferredContact && clubDetails.preferredContact !== 'N/A' && (
          <Box className="ClubDetailSection">
            <Typography variant="caption" className="SectionTitle" color="textSecondary">
              Preferred Contact
            </Typography>
            <Typography variant="body2" className="SectionContent" color="textPrimary">
              {clubDetails.preferredContact}
            </Typography>
          </Box>
        )}

        {/* Phone */}
        {clubDetails.phone && clubDetails.phone !== 'N/A' && (
          <Box className="ClubDetailSection">
            <Typography variant="caption" className="SectionTitle" color="textSecondary">
              Phone
            </Typography>
            <Typography variant="body2" className="SectionContent" color="textPrimary">
              {clubDetails.phone}
            </Typography>
          </Box>
        )}

        {/* Address */}
        {clubDetails.address && clubDetails.address !== 'N/A' && (
          <Box className="ClubDetailSection">
            <Typography variant="caption" className="SectionTitle" color="textSecondary">
              Address
            </Typography>
            <Typography variant="body2" className="SectionContent" color="textPrimary">
              {clubDetails.address}
            </Typography>
          </Box>
        )}

        {/* Website */}
        {clubDetails.website && clubDetails.website !== 'N/A' && (
          <Box className="ClubDetailSection">
            <Typography variant="caption" className="SectionTitle" color="textSecondary">
              Website
            </Typography>
            <Link
              href={websiteHref}
              target="_blank"
              rel="noopener noreferrer"
              className="SectionContent WebsiteLink"
            >
              {clubDetails.website} <OpenInNewOutlined color="primary" />
            </Link>
          </Box>
        )}
      </MuiDialogContent>
    </Dialog>
  );
};

export default ClubDetailDialog;
